// extracted by mini-css-extract-plugin
export default {"sideBar":"RouterTemplate_sideBar__XjSdd","appBody":"RouterTemplate_appBody__P7fGZ","loginBody":"RouterTemplate_loginBody__z7Rpq"};